import React from 'react';

import * as Styled from './popup-menu.style';

export type PopupMenuListItemProps = React.ComponentProps<'li'> & {
  children: React.ReactNode;
};

export const PopupMenuListItem: React.FC<PopupMenuListItemProps> = ({
  children,
  ...rest
}) => <Styled.ListItem {...rest}>{children}</Styled.ListItem>;
